import React, { useState } from 'react';
import { getIconPath } from '../utils/iconUtils';

const Icon = ({ 
  name, 
  alt = "Icon", 
  className = "", 
  style = {},
  width,
  height,
  onClick,
  fallbackIcon = null,
  showFallback = true
}) => {
  const [imageError, setImageError] = useState(false);
  const [currentSrc, setCurrentSrc] = useState(getIconPath(name));

  const handleImageError = (e) => {
    console.warn(`Icon failed to load: ${e.target.src}`);
    
    if (!imageError) {
      // Try alternative path formats
      const altSrc = `/icons/${name}`;
      setCurrentSrc(altSrc);
      setImageError(true);
    } else if (fallbackIcon && currentSrc !== fallbackIcon) {
      // Try fallback icon
      setCurrentSrc(fallbackIcon);
    } else {
      // Hide the image if all attempts failed
      setImageError(true);
      if (!showFallback) {
        e.target.style.display = 'none';
      }
    }
  };

  const handleImageLoad = () => {
    setImageError(false);
  };

  // If all loading attempts failed and showFallback is false, return null
  if (imageError && !showFallback && !fallbackIcon) {
    return null;
  }

  // If we have a fallback and image failed, show fallback text/icon
  if (imageError && showFallback && !fallbackIcon) {
    return (
      <div 
        className={`icon-fallback ${className}`}
        style={{
          width: width || '20px',
          height: height || '20px',
          backgroundColor: '#f0f2f5',
          borderRadius: '4px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontSize: '10px',
          color: '#65676b',
          ...style
        }}
        onClick={onClick}
      >
        {alt.charAt(0).toUpperCase()}
      </div>
    );
  }

  return (
    <img
      src={currentSrc}
      alt={alt}
      className={className}
      style={{
        objectFit: 'contain',
        ...style
      }}
      width={width}
      height={height}
      onClick={onClick}
      onError={handleImageError}
      onLoad={handleImageLoad}
    />
  );
};

export default Icon; 